// extracted by mini-css-extract-plugin
module.exports = {"fullScreenControl":"fullScreenControl___1EiXH","blockWrapperBox":"blockWrapperBox___2MIiH"};